import { useContext, useEffect, useState } from 'react';
import { HostPlatform } from '../config/hostPlatform';
import { GlobalContext } from '../context/GlobalState';
import { ROUTE_PATHS } from './urlState';

function useRoutePathForScreen() {
  const isAzure = HostPlatform.isAzure();
  const isJira = HostPlatform.isJira();
  const [currentLocalPath, setCurrentLocalPath] = useState();
  const { screen, currentRetrospectiveId } = useContext(GlobalContext);

  useEffect(() => {
    if (screen && (isAzure || isJira)) {
      const localPath = ROUTE_PATHS[screen]({ currentRetrospectiveId });
      setCurrentLocalPath(localPath);
    }
  }, [currentRetrospectiveId, isAzure, isJira, screen]);

  return currentLocalPath;
}

export default useRoutePathForScreen;
